// @ts-nocheck
import { defineComponent, computed } from 'vue';
import type { PropType } from 'vue';
import type { SVGJson, TreeObj } from '../utils/use-render';
import { renderFn, formatColor } from '../utils/use-render';
import { useNamespace } from '@nio-fe/shared';
import '../style/index.scss';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"#E83030","d":"M4.96 2a.9.9 0 00-.67.3C4.1 2.5 4 2.75 4 3v18c0 .25.1.52.29.7.19.2.43.3.67.3h14.08c.24 0 .5-.1.67-.3A1 1 0 0020 21V7.5L14.5 2H4.96z"}},{"tag":"path","attrs":{"fill":"#FADFDA","d":"M20 7.5h-4.47a1 1 0 01-.72-.3.98.98 0 01-.31-.73V2L20 7.5z","opacity":0.5}},{"tag":"path","attrs":{"fill":"#fff","fill-rule":"evenodd","d":"M13.77 8.71c.53.15 1.03.62 1.03 1.29 0 .1-.03.21-.07.3-.04.1-.1.2-.16.3-.12.2-.3.45-.5.7-.3.36-.66.76-1.06 1.17a22.44 22.44 0 00.42 1.62c.29.1.56.22.81.33.63.27 1.18.57 1.47.87.29.28.45.59.5.9.04.3-.05.59-.23.81-.35.44-1 .57-1.61.27-.2-.1-.38-.31-.52-.53-.15-.24-.3-.53-.43-.87-.17-.39-.33-.84-.48-1.31a19.93 19.93 0 00-1.66-.5c-.23.18-.46.36-.69.52-.3.2-.58.38-.84.5-.26.13-.52.22-.75.22a1.4 1.4 0 01-.9-.27.92.92 0 01-.34-.67c-.01-.23.05-.47.15-.66.1-.19.26-.37.46-.47.18-.1.42-.12.67-.13.26 0 .55.02.88.06.37.05.78.14 1.21.24a20.1 20.1 0 001.23-1.13c-.08-.43-.15-.84-.2-1.21-.04-.36-.06-.7-.06-.98 0-.26.04-.53.13-.71.33-.66 1-.81 1.54-.66zm-.9 3.04a15.3 15.3 0 001.2-1.46l.1-.22.03-.07c0-.33-.25-.61-.6-.71-.32-.1-.66 0-.83.34-.03.07-.06.21-.07.46a14.11 14.11 0 00.17 1.65zm-.36 1.21l-.05.06-.62.56a20.5 20.5 0 01.9.27 23.77 23.77 0 01-.23-.89zm-1.98.92a11.02 11.02 0 00-1.48-.18c-.22 0-.35.04-.42.07a.5.5 0 00-.19.21.67.67 0 00-.08.35c0 .1.04.18.12.24.08.06.23.13.52.13.1 0 .26-.04.49-.15a5.64 5.64 0 001.04-.67zm3.13.95c.1.29.2.56.31.81.13.32.27.58.39.77.13.21.21.3.27.32.4.2.74.08.89-.1.07-.1.1-.22.09-.36-.02-.15-.1-.34-.32-.56-.2-.2-.66-.47-1.29-.74l-.34-.14z","clip-rule":"evenodd"}}]};

export default defineComponent({
  name: 'IconPdfFilledLight',
  props: {
    color: {
      type: [Array, String] as PropType<string[] | string>,
      required: false,
      default: () => [],
    },
    spin: {
      type: String as PropType<'cw' | 'ccw'>,
      required: false,
    },
    size: {
      type: [String, Number],
      required: false,
      // default: 24,
    },
    rotate: {
      type: Number,
      required: false,
    },
  },
  emits: {
    click: (evt: MouseEvent) => evt instanceof MouseEvent,
  },
  setup(props, { attrs, emit }) {
    return () => {
      const { size, color, spin, rotate } = props;
      const prefix = `${useNamespace()}-icon`.toLowerCase();

      const spinClassName = `${spin ? `${prefix}_spin-${spin}` : ''}`;
      const iconStyle = computed(() => ({
        fontSize: size,
        transform: `rotate(${rotate}deg)`,
        ...(attrs.style as StyleSheet),
      }));
      const finalColor = computed(() => formatColor(color));
      const finalClass = computed(() => [prefix, `${prefix}__pdf_filled_light`, spinClassName, attrs.class]);
      const finalProps = {
        class: finalClass.value,
        style: iconStyle.value,
        onClick: (evt: MouseEvent) => emit('click', evt),
      };

      return renderFn(element, finalProps, finalColor.value as TreeObj);
    };
  },
});
